import { ArticleDto } from '@shared/interfaces/dtos/article-dto.interface';
import { NewBudgetArticle } from '@shared/interfaces/new-budget-article.interface';
import { BaseHttpService } from '@core/services/base-http.service';
import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { Query } from '@shared/interfaces/query.interface';
import { isArray } from 'lodash';
import { PagedResponse } from '@shared/interfaces/paged-response.interface';
import { NotCorrectlyImportedBudgetArticle } from '@shared/interfaces/not-correctly-imported-budget-article.interface';

@Injectable({
  providedIn: 'root',
})
export class ArticlesService extends BaseHttpService<
  ArticleDto,
  NewBudgetArticle
> {
  allowedMethods: {
    INSERT: boolean;
    FETCHONE: boolean;
    FETCHALL: boolean;
    UPDATE: boolean;
    DELETE: boolean;
  } = {
    INSERT: true,
    FETCHONE: false,
    FETCHALL: true,
    UPDATE: true,
    DELETE: true,
  };
  endpoint: string = 'articles';

  public getArticle(articleId: number | null): ArticleDto | undefined {
    if (articleId) {
      return this.state().items.find((article) => articleId === article.id);
    } else return undefined;
  }

  public searchArticlesByField(
    field: 'label' | 'code',
    search: string,
    query: Query,
  ): Observable<ArticleDto[]> {
    return this.http
      .get<ArticleDto[]>(this.buildUrl(), {
        params: this.getHttpParams({ [field]: search, ...query }),
      })
      .pipe(
        tap((res) => {
          if (!isArray(res) && (res as PagedResponse<ArticleDto>).count) {
            this.state.update((state) => ({
              ...state,
              ttlItems: (res as PagedResponse<ArticleDto>).count,
            }));
          }
        }),
        map((res) =>
          isArray(res) ? res : (res as PagedResponse<ArticleDto>).rows,
        ),
      );
  }

  public importArticlesWithExcelFile(file: File): Observable<{
    articlesCreated: number;
    articlesNotCreated: NotCorrectlyImportedBudgetArticle[];
  }> {
    const formData = new FormData();
    formData.append('file0', file);

    return this.http.post<{
      articlesCreated: number;
      articlesNotCreated: NotCorrectlyImportedBudgetArticle[];
    }>(`${this.buildUrl()}/excel`, formData);
  }
}
